package util

import kotlinx.browser.window
import org.w3c.dom.events.Event

inline fun <reified T : Event> castedEventListener(
    event: String,
    crossinline listener: (T) -> Unit,
) {
    window.addEventListener(event, {
        (it as? T)?.let(listener)
    })
}